import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { BlankPage, Hint, Loading, Nav } from "@/components";
import { Store, Common } from "@/constant";
import { Pagination, LightBoxDelete, LightBoxReset } from "@/layout";
import { StoreUserModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { UserInfo } from "@/types/Login";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";

@Component<StoreUserListController>({
    components: {
        BlankPage,
        Hint,
        Loading,
        Nav,
        Pagination,
        LightBoxDelete,
        LightBoxReset,
    }
})
export default class StoreUserListController extends Vue {
    private isLoading = true;
    private expireTime = 0;
    private typeMap = Store.AccountTypeMap;

    // 列表
    private userList: TCBReceiptApi.Protobuf.IStoreUser[] = [];

    // LB
    private lightBoxShow: { delete: boolean; hint: boolean } = {
        delete: false,
        hint: false
    };
    private selectedDeleteId = 0;
    private hintMessage = "";

    private pagination: {
        current: number;
        total: number;
        limit: number;
    } = {
            current: 1,
            total: 0,
            limit: 10
        };

    // Reset
    private selectedResetId = 0;
    private lightBoxShowForReset: {
        reset: boolean;
        hint: boolean;
    } = {
            reset: false,
            hint: false
        };

    // Hint
    private resetDone = false;
    private delDone = false;
    private hintBox: { show: boolean; hint: string } = { show: false, hint: "" };

    // priv
    private priv = TCBReceiptApi.Protobuf.Permission.create();

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        this.isLoading = true;

        await this.getStoreUser();

        this.isLoading = false;
    }

    private async getStoreUser() {
        const userInfo: UserInfo = JSON.parse(Cookies.get("appUserInfo") as string);
        const tidNumber = userInfo.identification as string;

        const item = TCBReceiptApi.Protobuf.StoreUserQuery.create({
            identification: tidNumber,
            pagination: this.getPagination(false),
        });

        console.log("item");
        console.log(item);

        const storeUserQuery = TCBReceiptApi.Protobuf.StoreUserQuery.encode(item).finish();
        await StoreUserModel.getStoreUser(storeUserQuery);

        const storeUserList = StoreUserModel.getStoreUserList();
        console.log(storeUserList);
        this.userList = storeUserList.list;
        this.pagination.total = storeUserList.total;

        console.log(this.userList);
    }

    /* Pagination */
    private prev() {
        this.pagination.current--;
        this.getStoreUser();
    }

    private next() {
        this.pagination.current++;
        this.getStoreUser();
    }

    private to(specificPagination: number) {
        this.pagination.current = specificPagination;
        this.getStoreUser();
    }

    private getPagination(isSearch: boolean) {
        const offset = isSearch
            ? 0
            : this.pagination.limit * (this.pagination.current - 1);

        const pagination = TCBReceiptApi.Protobuf.Pagination.create({
            limit: this.pagination.limit,
            offset: offset
        });

        return pagination;
    }
    /* Pagination */

    /* Delete */
    private openLightBoxDelete(index: number) {
        this.selectedDeleteId = this.userList[index].storeUserId as number;
        this.lightBoxShow.delete = true;
    }

    private closeLightBoxDelete() {
        this.lightBoxShow.delete = false;
        this.selectedDeleteId = 0;
    }

    private async confirmDelete() {
        this.isLoading = true;

        // send value
        const item = TCBReceiptApi.Protobuf.StoreUser.create({
            storeUserId: this.selectedDeleteId
        });
        const storeUser = TCBReceiptApi.Protobuf.StoreUser.encode(item).finish();
        const errorCode = await StoreUserModel.deleteStoreUser(storeUser); // deleteStoreUser
        this.lightBoxShow.delete = false;

        if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
            this.delDone = true;
            this.openHint("刪除成功");
        } else {
            this.openHint(Common.ErrorCodeMap[errorCode]);
        }

        this.lightBoxShow.hint = true;
        this.isLoading = false;
    }

    private reloadPage() {
        this.$router.go(0);
    }
    /* Delete */

    /* Reset */
    private openLightBoxReset(index: number) {
        this.selectedResetId = this.userList[index].storeUserId as number;
        this.lightBoxShowForReset.reset = true;
    }

    private closeLightBoxReset() {
        this.lightBoxShowForReset.reset = false;
    }

    private async passwordReset() {
        this.isLoading = true;

        // send value
        const item = TCBReceiptApi.Protobuf.StoreUser.create({
            storeUserId: this.selectedResetId
        });
        const storeUser = TCBReceiptApi.Protobuf.StoreUser.encode(item).finish();
        const errorCode = await StoreUserModel.resetPassword(storeUser);
        if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
            this.resetDone = true;
        }

        this.lightBoxShowForReset.reset = false;
        this.openHint(Common.ErrorCodeMap[errorCode]);
        this.isLoading = false;
    }
    /* Reset */

    /* Hint */
    private openHint(hint: string) {
        this.hintBox.show = true;
        this.hintBox.hint = hint;
    }

    private closeHint() {
        if (this.delDone || this.resetDone) {
            this.reloadPage();
        } else {
            this.hintBox.show = false;
            this.hintBox.hint = "";
        }
    }
    /* Hint */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }

        this.priv = Priv._getPriv() as TCBReceiptApi.Protobuf.Permission;
        console.log(this.priv);

        this.expireTime = Priv._getExpireTime();        
    }
    /* 取得最新的權限map並判斷有何權限 */
}
